import { useCallback, useEffect } from 'react'

const debug = false
const disableMetaEvents = process.env.REACT_APP_DISABLE_META_EVENTS === 'true'
const useAnalytics = (screenName: string) => {
  const onOther = useCallback(
    (event: string, params?: any) => {
      const EVENT_NAME = `${screenName}_${event}`
      if (!disableMetaEvents) {
        fbq('trackCustom', EVENT_NAME, params)
      }
      gtag('event', EVENT_NAME, { ...params, transport_type: 'beacon', debug_mode: debug })
    },
    [screenName],
  )
  useEffect(() => {
    onOther(`load`)
  }, [onOther])

  return {
    setUserId: (userId: string, eventName: string) => {
      if (!disableMetaEvents) {
        fbq('trackCustom', 'userData', { user_id: userId })
      }
      gtag('set', {
        user_id: userId,
        transport_type: 'beacon',
        debug_mode: debug,
      })
      onOther(eventName)
    },
    onOther,
  }
}

export default useAnalytics
